import type { ReactNode } from 'react'
import './receipts-service.css'

/**
 * Рамка раздела «Коды кассиров». Чеков здесь нет: их смотрят в «Статистике по продажам». Собственные кассиры и их объединение — в карточке
 * кассира (пункт меню «Кассиры»), решение владельца 02.11.2026. «Коды по источникам» — прежний вход «кассир источника + код»; удаляется в RP-CU6.
 * Вид окна «Связи кассиров» открывается из статистики кассира и показывается в той же рамке.
 */
export function ReceiptsServiceScreen({ children }: { children: ReactNode }) {
  return <section className="receipts-service" aria-label="Коды кассиров">{children}</section>
}
